export default "__VITE_PUBLIC_ASSET__2cd0871c__"